import {LinkTarget, type LinkTargetKind} from "./link-target";

/**
 * Lossless fallback for a `target` whose `kind` isn't (or is no longer) one of
 * the known concrete `LinkTarget` subclasses — a design decision made during planning:
 * `LinkTargetSerializer.fromJSON()` must NEVER return `null`/drop data for an
 * unrecognized `kind` (e.g. a future `IssueLinkTarget` that once existed and
 * was later removed from the code, but is still sitting in someone's old
 * `localStorage`) or a known `kind` with a malformed payload (e.g.
 * `{kind:'external'}` without a `url`). Silently coercing either case to "no
 * target" would permanently drop the tile's link data on the very next
 * `saveTiles()` round-trip (Gridstack `change` events persist the WHOLE board
 * on every drag).
 *
 * Carries the raw, unvalidated JSON verbatim so `toJSON()` writes back exactly
 * what was read — a tile with an `UnknownLinkTarget` renders as a
 * `link-tile-plain` (no registry entry matches its `kind`) but keeps its data
 * intact until a user explicitly replaces it via the edit dialog.
 */
export class UnknownLinkTarget extends LinkTarget {

    public readonly kind: LinkTargetKind;

    public constructor(private readonly raw: Record<string, unknown>) {
        super();
        this.kind = raw.kind as LinkTargetKind;
    }

    public toJSON(): Record<string, unknown> {
        return this.raw;
    }

}
